;( function( $, undefined )
{
    $( function()
    {
        window.common = {
            els: {
                $html: $('html'),
                $body: $('body'),
                $pdc6: $('#PDC6-main-container'),
                $win: $(window),
                $hero: $('#theHero'),
                $doc: $(document),
                $liaPage: $('body > .lia-page')
            }
        };

        var els = window.common.els;

        if ( !!( 'ontouchstart' in window ) ) {
            $('html').addClass( 'touch-device' );
        }

        var options = {
            els : els
        };

        $.fn.optimiser( options );
        els.$body.header( options );
        $.fn.footer( options );
        $.fn.capone( options );

        if( els.$pdc6.hasClass( 'user-page' ) )
        {
            $.fn.Users(options);
        }

        if( els.$pdc6.hasClass( 'home' ) )
        {
            $.fn.BrowseTopics( options );
        }
        else if( els.$pdc6.hasClass( 'user-badges' ) )
        {
            $.fn.UserBadges( options );
        }
        else if( els.$pdc6.hasClass( 'search' ) )
        {
            $.fn.SearchPage( options );
        }
        else if( els.$pdc6.hasClass( 'view-profile-page' ) )
        {
            $.fn.UserProfile( options );
        }
        else if( els.$pdc6.hasClass( 'user-settings-page' ) )
        {
            $.fn.UserSettings(options);
        }
        else if( els.$pdc6.hasClass( 'page-ForumPage' ) || els.$pdc6.hasClass( 'layout-categorypage-maincategory' ) )
        {
            $.fn.BoardHero( options );

            if( els.$pdc6.hasClass( 'layout-categorypage-maincategory' ) || els.$pdc6.hasClass('page-ForumPage') )
            {
                var $mainCategory = $( '#main-category' ),
                    endpoint      = $mainCategory.data( 'endpoint' ),
                    pages         = 3;

                if (els.$pdc6.hasClass('page-ForumPage')) {
                    $list = $('.normal-posts .threads-list-views');
                } else {
                    $list = $('.threads-list-views');
                }

                $list.Snoozy( {
                    target        : '.threads-list-views',
                    endpoint      : endpoint,
                    pages         : pages,
                    pageParamName : '/lazy-page/',
                    params        : {
                        sceeajax : true
                    }
                } );
            }
        }
        else if( els.$pdc6.hasClass( 'recent-posts-page' ) )
        {
            var $mainCategory = $( '#main-category' ),
                endpoint      = $mainCategory.data( 'endpoint' ),
                pages         = 3;

                $( '.threads-list-views' ).Snoozy( {
                    target        : '.threads-list-views',
                    endpoint      : endpoint,
                    pages         : pages,
                    pageParamName : '/lazy-page/',
                    params        : {
                        sceeajax : true
                    }
                } );
        }
        else if( els.$pdc6.hasClass( 'thread' ) )
        {
            $.fn.Thread( options );
        }
        else if( els.$pdc6.hasClass( 'recent-discussions' ) )
        {
            var endpoint = $( '.bottom.with-pagination' ).find( '.lia-paging-page-next.lia-component-next a' ).attr( 'href' ).replace( '/page/2', '' )
              , pages    = $( '.bottom.with-pagination' ).find( '.lia-paging-full-pages' ).children().size();

            $( '.threads-list-views' ).Snoozy( {
                target   : '.threads-list-views',
                endpoint : endpoint,
                pages    : pages,
                params   : {
                    sceeajax : true
                }
            } );
        }

        if( $( '.popular-topics-carousel' ).size() )
        {
            $.fn.PopularTopics();
        }

        if( $( '#pdc6-modal-ranking-up' ).size() )
        {
            $( '#pdc6-modal' ).RankingUp( options );
        }
    } );

} )( jQuery );
